module.exports = __webpack_public_path__ + "../resources/img/EF_Layer2.92fd8a0e.svg";